import './polyfill/trim'
import ElementSelector from './element/selector'
import Ajax from './ajax/ajax'

/**
 * Meta main function
 * @example
 * map.animateTo({
 *     zoom : 13,
 *     center : [0, 0],
 *     pitch : 30,
 *     bearing : 60
 * }, {
 *     duration : 6000,
 *     easing : 'out'
 * }, function(frame) {
 *     if (frame.state.playState === 'finished') {
 *         console.log('animation finished');
 *     }
 * });
 * @param selector {String} - 选择器，可以为类名，id，字符串，Element
 * @param context {Object} - 上下文
 * @returns {ElementSelector} - Meta实例
 * @constructor
 */
const Meta = (selector, context) => {
  return new ElementSelector(selector, context)
}

Meta.ajax = new Ajax()
export default Meta
